import React from 'react';
import Loadable from 'react-loadable';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';

let PageComponent = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  PageComponent = require('./franchise_page').default;
}

export default function franchisePage(store) {
  const routeConfig = {
    path:
      '/:slug(amazon-taking-over-complete-guide|next-big-things-in-tech/2021)',
    component() {
      if (PageComponent) {
        return <PageComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    // autoScrollOff: true,
    loadData: PageComponent ? PageComponent.loadData(store) : false,
    preloadChunk() {
      return import('./franchise_page').then(resp => {
        PageComponent = resp.default;
        routeConfig.loadData = PageComponent.loadData(store);

        return PageComponent;
      });
    },
    chunk: 'franchisePage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}
